import { forwardRef, useEffect, useRef } from "react";
import { Footer } from "../Footer/Footer";
import { Outlet } from "react-router-dom";
import Header from "@components/Header/Header";
import { useSelector } from "react-redux";
import type { RootState } from "@store/store";
import useNotifications from "@features/Notification/useNotifications";
import Sidebar from "@components/Sidebar/Sidebar";
import ModalManager from "@components/common/ModalManager/ModalManager";
import ChairmanContentGuard from "@components/RouteGuards/ChairmanContentGuard";

export const MainLayout = forwardRef<HTMLElement>(() => {
	const isAuthenticated = useSelector((state: RootState) => state.user.isAuthenticated);
	const { fetchInitial } = useNotifications();
	const fetchedRef = useRef(false);

	useEffect(() => {
		if (isAuthenticated && !fetchedRef.current) {
			fetchInitial();
			fetchedRef.current = true;
		}
	}, [isAuthenticated, fetchInitial]);

	return (
		<div className="flex flex-col bg-[#F7FAFD] min-h-screen">
			<Header />
			<Sidebar />
			<div className="flex-1 ml-72 flex flex-col">
				<main className="flex-1 p-2">
					<ChairmanContentGuard>
						<Outlet />
					</ChairmanContentGuard>
				</main>
				<Footer />
			</div>
			<ModalManager />
		</div>
	);
});
